import React from 'react';
import { UserContext } from './UserContext';
import { authAPI } from '../../InterfaceAPI/authAPI';
import withSplashMessage from '../splashMessage/withSplashMessage';
import { stringfyServerErrors } from '../../helpers/util';

class UserProvider extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      user: {},
      login: this.login,
      loginOverride: this.loginOverride,
      logout: this.logout,
      resetPassword: this.resetPassword,
      isLoggedIn: this.isLoggedIn,
      isAuthorized: this.isAuthorized
    };

    // clear the user when the api detects logout
    authAPI.registerLogoutCallback(this.handleAPILogout);
  }

  render() {
    return (
      <UserContext.Provider value={this.state}>
        {this.props.children}
      </UserContext.Provider>
    );
  }

  isAuthorized = (role = 'admin') => {
    const { user } = this.state;
    return (
      user &&
      'isAuth' in user &&
      user.isAuth &&
      (user.role === role || user.role === 'admin')
    );
  };

  isLoggedIn = () => {
    const { user } = this.state;
    return user && 'isAuth' in user && user.isAuth;
  };

  login = (userData, redirectTo = '/') => {
    console.log('login ', userData);
    authAPI
      .logIn(userData)
      .then(user => {
        user.role = userData.role;
        user.isAuth = true;
        this.setState({ user });

        if (redirectTo !== '') window.location = redirectTo; // this only works because it's outside the router
      })
      .catch(e => {
        console.log(e + ' \n Incorrect login ');
        this.props.addMessage({ className: 'error', message: 'Invalid Login' });
      });
  };

  loginOverride = user => this.setState({ user });

  logout = () => {
    authAPI
      .logOut(this.state.user.role)
      .then(res => {
        this.setState({ user: {} });
        this.props.addMessage({
          className: 'success',
          message: "You've been logged out. Thank you."
        });
        window.location = '/';
      })
      .catch(e => {
        console.log(e + ' \n Incorrect log out ');
        this.setState({ user: {} }); // flush the user any way
        window.location = '/';
      });
  };

  resetPassword = (userData, redirectTo = '/') => {
    authAPI
      .resetPassword(userData)
      .then(({ data: user }) => {
        user.role = userData.role; // temp ...
        user.isAuth = true;
        this.setState({ user });
        this.props.addMessage({
          className: 'success',
          message: 'Your password was updated.'
        });

        if (redirectTo !== '') window.location = redirectTo; // this only works because it's outside the router
      })
      .catch(e => {
        console.log(e + ' \n Reset Password Failed ');
        this.props.addMessage({
          className: 'error',
          message: stringfyServerErrors(e)
        });
      });
  };

  handleAPILogout = () => {
    this.setState({
      user: {},
      splashMessage: { className: 'error', message: 'Login to continue.' }
    });
  };

  componentWillMount() {
    // local storage
    const localStorageRef = localStorage.getItem(`user`);
    if (localStorageRef) {
      this.setState({ user: JSON.parse(localStorageRef) });
    }
  }

  componentWillUpdate(nextProps, nextState) {
    localStorage.setItem('user', JSON.stringify(nextState.user));
  }
}

export default withSplashMessage(UserProvider);



// WEBPACK FOOTER //
// ./src/components/auth/UserProvider.js